import { useTheme } from 'styled-components';
import { Theme } from '../../Theming';

export interface SvgProps {
  className?: string;
  color?: string;
  height?: number;
  style?: React.CSSProperties;
  width?: number;
  strokeWidth?: number;
}

export const useDefaultColor = (
  color?: string,
  key: keyof Theme['colors'] = 'darkestGrey'
) => {
  const { colors } = useTheme();

  return color ?? colors[key];
};

export interface QuotesSvgProps extends SvgProps {
  type: 'open' | 'closed';
}
